import React, { useMemo, useRef } from 'react'
import styles from 'components/Filters/FilterPanel/filter-panel.module.scss'
import PropTypes from 'prop-types'
import SubButtons from 'components/Filters/FilterPanel/subcomponents/SubButtons'
import clsx from 'clsx'
import FilterDropdownButton from 'components/Filters/FilterPanel/subcomponents/FilterDropdownButton'
import FilterControlItem from 'components/Filters/FilterPanel/subcomponents/FilterControlItem'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import 'components/Filters/FilterPanel/filter-panel.scss'
import extractComponents from 'components/Filters/FilterPanel/utils/extractComponents'
import { Grid } from 'gu-ui-kit'

const FilterPanel = ({
  filterManager,
  className,
  ControlWrapper = React.Fragment,
  AdditionalComponents = null,
  Header = null,
}) => {
  const breakpoints = useBreakpoint()
  const { configuration, filters } = filterManager
  const filterManagerRef = useRef(filterManager)
  const stableControlWrapperRef = useRef(ControlWrapper)
  filterManagerRef.current = filterManager

  if (!configuration) {
    return <></>
  }

  const onApplyByKey = useMemo(
    () =>
      Object.keys(configuration).reduce((acc, key) => {
        acc[key] = (val) => filterManagerRef.current.updateFilter({ fieldName: key, value: val })
        return acc
      }, {}),
    [configuration],
  )

  const firstPositionComponents = useMemo(
    () => extractComponents(configuration, 1),
    [configuration],
  )

  const secondPositionComponents = useMemo(
    () => extractComponents(configuration, 2),
    [configuration],
  )

  return (
    <div className={clsx(styles['filter-panel'], className)}>
      {Header && <Grid>{Header}</Grid>}
      <Grid
        gap={16}
        className={clsx(styles['filter-panel__controls-wrapper'], 'controls-wrapper')}
      >
        {breakpoints.fb && <FilterDropdownButton filterManager={filterManager} />}
        {firstPositionComponents.map(({ key, values, Component, className: controlClassName }) => (
          <FilterControlItem
            key={'filter-1-' + key}
            ControlWrapper={stableControlWrapperRef.current}
            Component={Component}
            className={controlClassName}
            name={key}
            values={values}
            value={filters?.[key]}
            onApply={onApplyByKey[key]}
            filterManager={filterManager}
          />
        ))}
        {secondPositionComponents.map(({ key, values, Component, className: controlClassName }) => (
          <FilterControlItem
            key={'filter-2-' + key}
            ControlWrapper={stableControlWrapperRef.current}
            Component={Component}
            className={controlClassName}
            name={key}
            values={values}
            value={filters?.[key]}
            onApply={onApplyByKey[key]}
            filterManager={filterManager}
          />
        ))}
        {AdditionalComponents}
      </Grid>
      <SubButtons filterManager={filterManager} />
    </div>
  )
}

FilterPanel.propTypes = {
  filterManager: PropTypes.object,
  className: PropTypes.string,
  ControlWrapper: PropTypes.elementType,
  Header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  AdditionalComponents: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FilterPanel
